<template>
  <div>
    <b-container>
      <div class="row justify-content-center">
        <div class="column w-75">
          <div class="mt-4 d-flex align-items-start justify-content-between">
            <back-arrow :title="$t('profile.title')"/>
            <i class="ph-custom ph-pencil edit-btn" @click="clickOnEditBtn"/>
          </div>

          <b-row class="mt-3">
            <b-col>
              <div class="page-title">{{ user.firstname }} {{ user.lastname }}</div>
              <div class="profile-username">{{ user.username }}</div>
            </b-col>
          </b-row>

          <b-row class="mt-4 mb-4">
            <b-col>
              <div class="category-card w-100 cursor-pointer" @click="redirectMyLampions">
                <div class="d-flex flex-column align-items-center w-100">
                  <div class="d-flex justify-content-center w-100">
                    <div class="page-title lampions-nb mr-2">{{ lampionsInfos.lampionsUser }}</div>
                    <img :src="require(`@/assets/images/b122/ic_coin.png`)" class="coin-image mt-2">
                  </div>
                  <div class="currentLoop mt-1 mb-2">
                    {{ lampionsInfos.currentLoop }}
                  </div>
                  <div class="w-100 d-flex flex-column align-items-center">
                    <b-progress
                      :max="lampionsInfos.nbPointsInCurrentLoop"
                      class="w-100 lampions-progress"
                      no-value
                    >
                      <b-progress-bar
                        :value="(lampionsInfos.currentNbOfPointsInLoop)"
                        class="lampions-progress-bar"
                      />
                    </b-progress>
                    <div class="lampions-progress-value">
                      {{ lampionsInfos.currentNbOfPointsInLoop }} / {{ lampionsInfos.nbPointsInCurrentLoop }}
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col>
              <div class="category-card mb-2 cursor-pointer" @click="redirectMyMatches">
                <div class="d-flex flex-column">
                  <h1 class="category-card-title">{{ $t('profile.matchs') }}</h1>
                  <p class="category-number">{{ user.matchsOfUser }}</p>
                </div>
                <div class="d-flex align-items-center mr-5">
                  <i class="category-icon ph-flashlight-bold"/>
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="category-card" @click="redirectMyAnnonce">
                <div class="d-flex flex-column">
                  <h1 class="category-card-title">{{ $t('profile.annonces') }}</h1>
                  <p class="category-number">{{ user.annoncesOfUser }}</p>
                </div>
                <div class="d-flex align-items-center mr-5">
                  <i class="category-icon ph-megaphone-bold"/>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <div class="profile-property">{{ $t('profile.dateBirth') }}</div>
              <div class="profile-value">{{ new Date(user.birthday).toLocaleDateString() }}</div>
            </b-col>
            <b-col>
              <div class="profile-property">{{ $t('profile.profession') }}</div>
              <div class="profile-value">{{ user.profession ? user.profession.text : "-" }}</div>
            </b-col>
            <b-col>
              <div class="profile-property">{{ $t('profile.phone') }}</div>
              <div class="profile-value">{{ user.phoneNumber }}</div>
            </b-col>
            <b-col>
              <div class="profile-property">{{ $t('profile.department') }}</div>
              <div class="profile-value">{{ user.department ? user.department.text : "-" }}</div>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col cols="3">
              <div class="profile-property">{{ $t('profile.identity') }}</div>
              <div class="mt-1 d-flex align-items-center">
                <i :class="(user && user.compte && user.compte.icon ? user.compte.icon : '') + ' mr-1 ph-xl ph-bold'" :style="{color: user.compte.color}" ></i>
                {{ user.compte ? $t(user.compte.text) : '' }}
              </div>
            </b-col>
            <b-col cols="3">
              <div class="profile-property">{{ $t('profile.rib') }}</div>
              <div v-if="user.rib && user.rib.id" class="profile-value link-rib" @click="clickOnRib()">
                {{ user.rib.originalFileName || user.rib.filename }}
              </div>
              <div v-else class="profile-value">
                {{ "-" }}
              </div>
            </b-col>
          </b-row>

          <b-row class="justify-content-center mt-4 mb-4">
            <div :class="user.askedToBeDeletedDate !==null ? 'delete-account-active' : 'delete-account'"
                 @click="clickOnDeleteAccount">
              {{
                user.askedToBeDeletedDate !== null ? $t('profile.delete.account.ongoing') : $t('profile.delete.account')
              }}
            </div>
          </b-row>

        </div>
      </div>

    </b-container>

    <AccountDeletionModal
      @hasValidatedAccountDeletion="hasValidatedAccountDeletion"
    ></AccountDeletionModal>
  </div>
</template>

<script>
import api from '../../services/api'
import ShowActions from '../../components/b122/ShowActions.vue'
import BackArrow from '../../components/b122/BackArrow.vue'
import AccountDeletionModal from "./AccountDeletionModal";

export default {

  name: 'ProfileShow',
  components: {AccountDeletionModal, BackArrow, ShowActions},

  data() {
    return {
      userId: this.$store.getters.userId,
      user: {},

      lampionsInfos: {},
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    async fetchData() {
      this.fetchUser()
      this.fetchLampions()
    },

    fetchUser() {
      api
        .get(`/user/getProfile`)
        .then(response => {
          this.user = response.data
        })
        .catch((error) => {
          // this.$router.push({
          //   name: '/',
          //   params: {
          //     message: error.response.data.message
          //   }
          // })
        })
    },

    fetchLampions() {
      api
        .get(`/user/getUserInfoLampions`)
        .then(response => {
          this.lampionsInfos = response.data
        })
        .catch((error) => {
          // this.$router.push({
          //   name: '/',
          //   params: {
          //     message: error.response.data.message
          //   }
          // })
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'ProfileEdit'
      })
    },

    redirectMyLampions() {
      this.$router.push({
        name: 'MyLampions'
      })
    },

    redirectMyAnnonce() {
      this.$router.push({
        name: 'MyAnnonce'
      })
    },

    redirectMyMatches() {
      this.$router.push({
        name: 'MyMatches'
      })
    },

    clickOnDeleteAccount() {
      if (this.user.askedToBeDeletedDate === null) {
        this.$bvModal.show("account-deletion-modal")
      }
    },

    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },

    hasValidatedAccountDeletion() {
      this.fetchUser()
    },

    clickOnRib() {
      window.open(this.getFileUrl(this.user.rib.fileUrl), '_blank')
    }
  }
}
</script>

<style scoped>
.edit-btn {
  color: var(--main-yellow-medium);
  font-size: 30px;
  cursor: pointer;
}

.category-card {
  height: 120px;
  background-color: var(--main-black-dark);
  border-radius: var(--fifth-border-radius);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}

.category-card-title {
  font-family: "KumbhSans-Regular", "Arial", sans-serif;
  font-size: var(--menu-font-size);
  color: var(--main-grey-light);
}

.category-number {
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: 54px;
  color: var(--main-yellow-medium);
  line-height: 50px;
}

.category-icon {
  font-size: 100px;
  color: var(--main-black-light);
}

.profile-username {
  color: var(--main-grey-medium);
}

.profile-property {
  color: var(--main-grey-medium);
  font-size: var(--small-font-size);
}

.profile-value {

}

.delete-account {
  color: var(--main-red-medium);
  text-decoration: underline;
  cursor: pointer;
}

.delete-account-active {
  color: var(--main-red-darker);
}

.coin-image {
  width: 24px;
  height: 24px;
}

.lampions-nb {
  font-size: 30px;
}

.currentLoop {
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  color: var(--main-yellow-medium);
}

.lampions-progress {
  background-color: var(--main-grey-dark);
  height: 20px;
}

.lampions-progress-bar {
  background-color: var(--main-yellow-medium);
}

.lampions-progress-value {
  position: relative;
  top: -24px;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--title-level-three-font-size);
  color: var(--main-black-darker);
}

.link-rib {
  color: var(--main-yellow-medium);
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/user/ProfileShow.vue